import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/navbar.css";
import smg from "../asset/SMG Logo.png";
import yantra from "../asset/saraswati yantra_Blue.png";
import AdmissionModal from "../pages/AdmissionModal"; // Import the modal component

const Navbar = () => {
  const [showModal, setShowModal] = useState(false);

  // Show/Hide Modal
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Gallery Links for dropdowns
  const galleryLinks = [
    { name: "Activities", path: "activities" },
    { name: "Events", path: "events" },
    { name: "Infrastructure", path: "infrastructure" },
  ];

  return (
    <div>
      <section id="navbar">
        <div className="container">
          <nav className="navbar navbar-expand-lg custom-navbar">
            <div className="container-fluid">
              {/* Logo and Brand Name */}
              <img className="navlogo" src={smg} alt="SMG LOGO" />
              <NavLink className="brand" to="/">
                SMG
              </NavLink>

              {/* Navbar Toggler Button for Mobile View */}
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              {/* Navbar Links */}
              <div className="collapse navbar-collapse" id="navbarNavDropdown">
                <div className="navbar-nav">
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                    to="/"
                  >
                    Home
                  </NavLink>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                    to="/about"
                  >
                    About
                  </NavLink>

                  {/* Dropdown Menu for "World of SMG" */}
                  <div className="nav-item dropdown">
                    <NavLink
                      className="nav-link dropdown-toggle"
                      to="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      World of SMG
                    </NavLink>
                    <ul className="dropdown-menu">
                      {galleryLinks.map((link) => (
                        <li key={link.path} className="dropdown-submenu">
                          <NavLink
                            className={({ isActive }) =>
                              isActive
                                ? "dropdown-item active"
                                : "dropdown-item"
                            }
                            to={`/${link.path}`}
                          >
                            {link.name}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Contact Link */}
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                    to="/contact"
                  >
                    Contact
                  </NavLink>
                </div>

                {/* Admissions Button and Yantra Image */}
                <div className="ms-auto">
                  {/* <button className="btn-pri" onClick={handleShowModal}>
                    Admissions 2025-26
                  </button> */}

                  <img className="yantra" src={yantra} alt="Saraswati Yantra" />
                </div>
              </div>
            </div>
          </nav>
        </div>
      </section>

      {/* Render Admission Modal */}
      <AdmissionModal show={showModal} handleClose={handleCloseModal} />
    </div>
  );
};

export default Navbar;
